import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingService } from 'src/app/shared/services/setting.service';
import { PageService } from 'src/app/services/page.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from 'src/app/shared/services/alert.service';
import { IPaymentAuthorization, IPaymentAuthorizationTransaction } from './gift-card.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';

export interface I3DSAuthorization {
  serverTransactionId: string;
  card: I3DSCardInfo,
  amount: number,
  terminal: string
}

export interface I3DSCardInfo {
  expiryMonth: string,
  expiryYear: string,
  securityCode: string,         
  cardHolderName: string,
  number: string,
  type: string
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient,
    private setting: SettingService,
    private page: PageService,
    private auth: AuthService,
    private alertService: AlertService,
    private apiController: ApiControllerService) {

  }

  savedCardAuthorization(paymentAuthorization: IPaymentAuthorization): Observable<IPaymentAuthorizationTransaction> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      /* this.http.post(this.setting.getLegacySmaUrl('V2/SavedCard/Authorization'), paymentAuthorization, {
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          response => {
            o.next(response);
          },
          response => {
            if (response.status === 500)
              this.alertService.showUnexpectedErrorMsg();
            o.error(response);
          }
        ); */

      this.apiController.post(this.setting.getLegacySmaUrl('V2/SavedCard/Authorization'), paymentAuthorization, {
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          response => {
            o.next(response);
          },
          response => {
            if (response.status === 500)
              this.alertService.showUnexpectedErrorMsg();
            o.error(response);
          }
        );
    });
  }

  savedCardConfirmation(authorizationTransaction: IPaymentAuthorizationTransaction): Observable<void> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      /* this.http.get(this.setting.getLegacySmaUrl('V2/SavedCard/ConfirmAuthorization'), {
        headers: headers,
        params: {
          ApiTransactionId: authorizationTransaction.ApiTransactionId
        }
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          () => {
            o.next();
          },
          response => {
            if (response.status === 500)
              this.alertService.showUnexpectedErrorMsg();

            o.error(response);
          }
        ); */

        this.apiController.get(this.setting.getLegacySmaUrl('V2/SavedCard/ConfirmAuthorization'), {
          headers: headers,
          params: {
            ApiTransactionId: authorizationTransaction.ApiTransactionId
          }
        })
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe(
            () => {
              o.next();
            },
            response => {
              if (response.status === 500)
                this.alertService.showUnexpectedErrorMsg();

              o.error(response);
            }
          );
    });
  }

  savedCardCancelAuthorization(apiTransactionId: string): Observable<void> {
    return Observable.create(o => {
      let headers = {}; 
      this.page.appendAuthorizationHeader(headers);

      let params = {
        ApiTransactionId: apiTransactionId
      };
      
      /* this.http.get(this.setting.apiUrl('V2/SavedCard/CancelAuthorization'), {
        headers: headers,
        params: params
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          () => {
            o.next();
          },
          response => {
            if (response.status === 500)
              this.alertService.showUnexpectedErrorMsg();

            o.error(response);
          }
        ); */

        this.apiController.get(this.setting.apiUrl('V2/SavedCard/CancelAuthorization'), {
          headers: headers,
          params: params
        })
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe(
            () => {
              o.next();
            },
            response => {
              if (response.status === 500)
                this.alertService.showUnexpectedErrorMsg();

              o.error(response);
            }
          );
    });
  }

  authorize3DS(data: I3DSAuthorization): Observable<boolean> {    
    return Observable.create(o => {
        /* this.http.post(this.setting.getLegacySmaUrl('GlobalThreeDS/ThreeDSecureAuthorisation'), data)
            .pipe(finalize(() => {
                o.complete();
            }))
            .subscribe((data: boolean) => {
                o.next(data);
            }, async error => {
              
                            
            }); */
        this.apiController.post(this.setting.getLegacySmaUrl('GlobalThreeDS/ThreeDSecureAuthorisation'), data)
          .pipe(finalize(() => {
              o.complete();
          }))
          .subscribe((data: boolean) => {
              o.next(data);
          }, async error => {
            
                          
          });
    });
  }
}
